<template>
    <div id="userListWrapper">
        <!-- 搜索栏 -->
        <div class="search-box">
            <div>
                <Select
                    v-model="selNowEnterId"
                    placeholder="请选择企业名称"
                    style="width:200px;margin-right: 10px;"
                    @on-change="enterpListChange"
                >
                    <Option
                        v-for="(item, index) in getEnterpriseList"
                        :key="index"
                        :value="item.dept_id"
                    >
                        {{ item.dept_cn_name }}
                    </Option>
                </Select>
                <Select
                    v-model="departmentId"
                    placeholder="请选择部门名称"
                    style="width:200px;margin-right: 10px;"
                    :clearable="true"
                    @on-change="departmentChange"
                >
                    <Option
                        v-for="(item, index) in departmentList"
                        :key="index"
                        :value="item.dept_id"
                    >
                        {{ item.dept_cn_name }}
                    </Option>
                </Select>
                <Select
                    v-model="departmentRoleId"
                    placeholder="请选择部门角色"
                    style="width:200px;margin-right: 10px;"
                    :clearable="true"
                    @on-change="DepartmentRoleChange"
                >
                    <Option
                        v-for="(item, index) in extDprlList"
                        :key="index"
                        :value="item.dprl_code"
                    >
                        {{ item.bk_expl }}
                    </Option>
                </Select>
                <Input
                    v-model="searchValue"
                    prefix="ios-search-outline"
                    placeholder="请输入用户"
                    style="width: 208px; margin-right: 10px;"
                    clearable
                    @on-enter="handleSearchClick"
                    @on-clear="handleSearchClick"
                />
                <Button class="ys-confirm" @click="handleSearchClick">搜索</Button>
            </div>
            <div>
                <Button
                    v-if="hasPerm('org_user_add_btn') == 2"
                    class="ys-confirm"
                    icon="ios-add"
                    @click="handleAddClick"
                >
                    新建
                </Button>
            </div>
        </div>
        <!-- 表格 -->
        <el-table
            :columns="Columns"
            :tableData="tableData"
            :loading="tableLoading"
            :tableHeight="tableHeight"
            @on-btn-click="onBtnClick"
        ></el-table>
        <!-- 分页 -->
        <div class="paging-box">
            <Page
                :total="totalCount"
                :page-size="12"
                :current="page"
                @on-change="handlePagingClick"
            />
        </div>
        <!-- 弹框 -->
        <layer-model
            v-if="currentStatusValues"
            :selNowEnterId="selNowEnterId"
            :currentStatusUser="currentStatusUser"
            :titleLayer="titleLayer"
            :editId="editId"
            @on-jurisdiction-click="onJurisdictionUserClick"
        ></layer-model>
        <div>
            <Alter ref="alterModal" :configData="configData" @change_ok="confirmDel"></Alter>
        </div>
        <!-- 权限弹框 -->
        <jurisdiction-model
            :popoutType="3"
            :explainInfo="explainInfo"
            :MenuPermissionList="MenuPermissionList"
            :BtnPermissionList="BtnPermissionList"
            :currentStatus="currentStatus"
            @on-jurisdiction-click="onJurisdictionClick"
            @selectedPermissionList="selectedPermissionList"
        ></jurisdiction-model>
    </div>
</template>
<script>
import JurisdictionModel from '_g/commonComponent/jurisdictionModel'; // 权限配置弹框
import {
    sys_getMenuPermission,
    sys_setMenuPermission,
    sys_setMenuPermissionByUser,
} from '@/utils/sys_utils/pulicServer'; // 获取权限配置数据
import { mapActions, mapGetters } from 'vuex';
import elementResizeDetectorMaker from 'element-resize-detector'; // 获取元素的高度
import ElTable from '_g/commonComponent/table/elTable.vue';
import LayerModel from '../components/userModel/layerModel';
// import Columns from './tableConfig.js'
export default {
    components: {
        'el-table': ElTable,
        'layer-model': LayerModel,
        'jurisdiction-model': JurisdictionModel,
    },
    data() {
        return {
            tableData: [], // 数据
            Columns: [], // 表头
            totalCount: 0, // 总条数
            tableHeight: 0,
            searchValue: '', // 搜索框的值
            page: 1, // 当前页
            currentStatusUser: false,
            currentStatusValues: false,
            titleLayer: '新建',
            configData: {}, // 弹框配置信息
            user_id: '', // 列表出删除用户的id
            editId: '', // 编辑用到的id
            selNowEnterId: '', // 当前选择的企业ID
            // 权限配置相关变量
            explainInfo: {}, // 权限配置弹框头部基础信息
            MenuPermissionList: [], // 菜单权限数据列表
            BtnPermissionList: [], //按钮权限列表
            currentStatus: false, // 打开权限列表弹框
            departmentList: [], //部门列表
            extDprlList: [], //部门角色列表
            departmentId: '',
            departmentRoleId: '',
            tableLoading: true, // 表格loading
        };
    },
    computed: {
        ...mapGetters(['getEnterpriseList', 'getCommData']),
    },
    methods: {
        setLockingStatus(id, status) {
            let param = {
                user_id: id,
                stat_no: status,
            };
            this.modifyUserLockStatus(param)
                .then(res => {
                    if (res.request_state) {
                        this.$Message.success('修改成功');
                        this.organizaLists();
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Message.error('修改失败');
                });
        },

        ...mapActions([
            'organizaList', // 获取页面列表
            'organizalDelete', // 用户删除
            'listDeptsByNameAction', //获取部门列表
            'PageExtDprlListAction', // 获取部门角色
            'modifyUserLockStatus', //设置用户锁
        ]),
        // 获取元素的高度
        getElementHeight() {
            let ERD = elementResizeDetectorMaker();
            let _this = this;
            ERD.listenTo(document.getElementById('userListWrapper'), element => {
                _this.tableHeight = element.offsetHeight - 66 - 60 - 20; // 在该基础上多-20跟分页有间距
            });
        },
        // 新建跟编辑封装
        processing(code) {
            this.currentStatusUser = true;
            this.currentStatusValues = true;
            this.titleLayer = code === 1 ? '编辑' : '新建';
        },
        // 操作按钮
        onBtnClick(rowItem, options) {
            switch (options.code) {
                case '权限配置': // 配置权限
                    this.explainInfo = rowItem;
                    // 获取菜单资源列表
                    this.getPermissionInfo({
                        type_code: 'user', // 用户类型
                        user_id: rowItem.user_id, // 用户ID
                        cull_type: 'cull',
                        ent_no: this.selNowEnterId, // 所属企业ID
                    });
                    // 获取按钮资源列表
                    this.getPermissionInfo(
                        {
                            cull_type: 'cull',
                            ent_no: this.selNowEnterId, // 所属企业ID
                            user_id: rowItem.user_id, // 用户ID
                            is_opt: true,
                        },
                        1
                    );
                    // 每次请求都需要清除原来数据
                    this.MenuPermissionList = [];
                    this.BtnPermissionList = [];
                    this.currentStatus = true;
                    break;
                case '编辑':
                    this.editId = rowItem.user_id;
                    this.processing(1);
                    break;
                case '删除':
                    this.user_id = rowItem.user_id;
                    this.DeleteComponent();
                    break;
            }
        },
        // 新建功能
        handleAddClick() {
            this.processing(2);
        },
        // 搜索功能
        handleSearchClick() {
            this.page = 1;
            // 获取列表
            this.organizaLists();
        },
        // 分页功能
        handlePagingClick(res) {
            this.page = res;
            // 获取列表
            this.organizaLists();
        },
        // 回调
        onJurisdictionUserClick(res) {
            this.currentStatusUser = false;
            this.currentStatusValues = false;
            // 刷新列表
            this.page = res ? res : this.page;
            this.organizaLists();
        },
        // 删除
        DeleteComponent(item) {
            this.configData = {
                type: 'warning',
                title: '警告',
                content: '是否删除当前信息',
            };
            this.$refs.alterModal.OpenModal();
        },
        confirmDel() {
            this.organizalDeletes();
        },
        getEnterListInit() {
            // 默认选择第一个企业
            this.$nextTick(() => {
                if (this.getEnterpriseList && this.getEnterpriseList.length > 0) {
                    this.selNowEnterId = this.getEnterpriseList[0].dept_id;
                    // 默认第一条调用部门下拉框数据
                    this.listDeptsByNameActions(this.getEnterpriseList[0].dept_id);
                    // 获取页面列表
                    this.organizaLists();
                }
            });
        },
        // 切换企业
        enterpListChange(enterpID) {
            this.selNowEnterId = enterpID;
            // 获取页面列表
            this.page = 1;
            this.organizaLists();
            this.listDeptsByNameActions(enterpID);
            this.GetPageExtDprlList();
        },
        //部门切换
        departmentChange(dpid) {
            this.departmentId = dpid;
            this.page = 1;
            this.organizaLists();
            this.GetPageExtDprlList();
        },
        // 部门角色切换
        DepartmentRoleChange(dprlid) {
            this.departmentRoleId = dprlid;
            this.page = 1;
            this.organizaLists();
        },
        // 所属部门查询
        async listDeptsByNameActions(id) {
            try {
                const data = await this.listDeptsByNameAction({
                    ent_id: id,
                });
                if (data.request_state) {
                    this.departmentList = data.dpDeptInfoList;
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 对应部门下的部门角色查询
        GetPageExtDprlList() {
            this.PageExtDprlListAction({
                ent_no: this.selNowEnterId,
                dept_id: this.selNowEnterId,
                bl_dept_id: this.departmentId,
                dept_cn_name: '',
            }).then(res => {
                if (res.request_state) {
                    this.extDprlList = res.dprl_list;
                }
            });
        },
        // 获取页面列表
        async organizaLists() {
            this.tableLoading = true;
            this.tableData = [];
            try {
                let ev = {
                    user_cn_name: this.searchValue || '', // 用户名查询
                    start_recd: (this.page - 1) * 12,
                    limit_recd: 12,
                    ent_no: this.selNowEnterId || '', // 重写企业ID
                    dept_no: this.departmentId || '',
                    dprl_id: this.departmentRoleId || '',
                };
                const datas = await this.organizaList(ev);
                if (datas.request_state) {
                    this.totalCount = datas.all_recd;
                    this.tableData = datas.user_list;
                    this.tableLoading = false;
                }
            } catch (error) {
                this.$Message.error(error);
                this.tableLoading = false;
            }
        },
        // 删除
        async organizalDeletes() {
            try {
                const data = await this.organizalDelete({
                    user_id: this.user_id,
                });
                if (data.request_state) {
                    this.$Message.success('删除成功~~');
                    // 刷新页面
                    this.organizaLists();
                }
            } catch (error) {
                this.$Message.error(error);
            }
        },
        // 配置权限弹框回调
        onJurisdictionClick(res) {
            this.currentStatus = false;
        },
        // 获取权限数据信息 type 0 获取菜单数据  1获取按钮数据
        getPermissionInfo(params, type = 0) {
            sys_getMenuPermission(params, type)
                .then(res => {
                    if (res) {
                        if (type == 1) {
                            this.BtnPermissionList = res;
                        } else {
                            this.MenuPermissionList = res;
                        }
                    }
                })
                .catch(err => {
                    this.$Message.error(err);
                });
        },
        // 保存配置的权限数据
        selectedPermissionList(menuList, BtnList) {
            // 如果返回菜单权限
            let params = {
                user_id: this.explainInfo.user_id, //当前用户ID
                rs_ary: [],
                opt_ary: [],
            };
            // 存在配置菜单权限
            if (menuList) {
                params.rs_ary = menuList;
            }
            // 存在配置按钮权限
            if (BtnList) {
                params.opt_ary = BtnList;
            }
            sys_setMenuPermissionByUser(params)
                .then(res => {
                    if (res) {
                        this.$Message.success('权限配置成功！');
                    }
                })
                .catch(err => {
                    this.$Message.error(err);
                });
        },
    },
    mounted() {
        // this.Columns = Columns;
        // 获取元素高度
        let user = JSON.parse(this.getCommData).org_user_id;
        this.getElementHeight();
        this.Columns = [
            {
                title: '用户名',
                key: 'user_id',
                ellipsis: true,
                tooltip: true,
            },
            {
                title: '用户姓名',
                key: 'user_cn_name',
            },
            {
                title: '联系电话',
                key: 'phone_no',
                render: (h, params) => {
                    return h(
                        'span',
                        user == 'admin'
                            ? params.row.phone_no
                            : params.row.user_id == user
                            ? params.row.phone_no
                            : '***********'
                    );
                },
            },
            {
                title: '邮箱',
                key: 'email_add',
                width: 300,
            },
            {
                title: '所属企业',
                key: 'ent_name',
                ellipsis: true,
                tooltip: true,
            },
            {
                title: '所属部门',
                key: 'dept_cn_name',
                ellipsis: true,
                tooltip: true,
            },
            {
                title: '权限配置',
                slot: 'iconfontconfig',
                iconClassConfig: [
                    {
                        name: 'ys-iconshezhi',
                        code: '权限配置',
                        status: 1,
                        Pname: 'org_user_jurisdiction_btn',
                    }, // 配置
                ],
            },
            {
                title: '操作',
                slot: 'iconfont',
                iconClass: [
                    {
                        name: 'ys-iconbianji',
                        code: '编辑',
                        status: 1,
                        Pname: 'org_user_edit_btn',
                    },
                    {
                        name: 'ys-iconlajitongbeifen',
                        code: '删除',
                        status: 1,
                        Pname: 'org_user_delete_btn',
                    },
                ],
            },
            {
                title: ' ',
                slot: 'stat_no',
                render: (h, params) => {
                    return h('div', [
                        h('div', {
                            class: params.row.stat_name == '禁用' ? 'lock-on' : 'lock-off',
                            style: {
                                width: '16px',
                                height: '16px',
                                cursor: 'pointer',
                            },
                            on: {
                                click: () => {
                                    //修改锁定状态
                                    this.setLockingStatus(
                                        params.row.user_id,
                                        params.row.stat_name == '禁用' ? '1' : '2'
                                    );
                                },
                            },
                        }),
                    ]);
                },
            },
        ];
    },
    created() {
        this.getEnterListInit();
    },
    watch: {
        getEnterpriseList() {
            this.getEnterListInit();
        },
    },
};
</script>
<style lang="less" scoped>
#userListWrapper {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 50px;
    box-sizing: border-box;
    overflow: hidden;

    .search-box {
        width: 100%;
        height: 66px;
        padding: 22px 0px 12px 0px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
    }

    .paging-box {
        position: fixed;
        bottom: 0px;
        right: 50px;
        z-index: 1;
        height: 60px;
        width: calc(100% - 250);
        text-align: right;
    }
}
</style>
